import React from "react"
import { Box, Text, Button } from "grommet"
import { MainLayout } from "../components/layout/MainLayout"
import { StatusCritical } from "grommet-icons"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

export default () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <MainLayout>
      <Box gap="medium" justify="center">
        <Box alignSelf="center">
          <StatusCritical size="xlarge" color="status-error" />
        </Box>
        <Text alignSelf="center" weight="bold">
          Cannot find page (404)
        </Text>
        <Button label={t("button.back")} onClick={() => navigate(-1)} />
      </Box>
    </MainLayout>
  )
}
